import React from "react";

const SignalSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="42.187"
      height="36.486"
      viewBox="0 0 42.187 36.486"
    >
      <path
        fill="#fff"
        d="M37.682 20.523h-3.42a1.14 1.14 0 00-1.14 1.14v13.683a1.14 1.14 0 001.14 1.14h3.421a1.14 1.14 0 001.14-1.14V21.664a1.14 1.14 0 00-1.141-1.141zm-9.121 6.841H25.14A1.14 1.14 0 0024 28.5v6.841a1.14 1.14 0 001.14 1.14h3.421a1.14 1.14 0 001.14-1.14V28.5a1.14 1.14 0 00-1.14-1.136zM46.8 13.682h-3.417a1.14 1.14 0 00-1.14 1.14v20.524a1.14 1.14 0 001.14 1.14H46.8a1.14 1.14 0 001.14-1.14V14.822a1.14 1.14 0 00-1.14-1.14zm9.121-6.841H52.5a1.14 1.14 0 00-1.14 1.14v27.365a1.14 1.14 0 001.14 1.14h3.421a1.14 1.14 0 001.14-1.14V7.981a1.14 1.14 0 00-1.136-1.14zM65.047 0h-3.421a1.14 1.14 0 00-1.14 1.14v34.206a1.14 1.14 0 001.14 1.14h3.421a1.14 1.14 0 001.14-1.14V1.14A1.14 1.14 0 0065.047 0z"
        data-name="signal-solid (1)"
        transform="translate(-24)"
      ></path>
    </svg>
  );
};

export default SignalSVG;
